import { CommonResponse } from "@gtpl/shared-models/masters";
import connection from "./connection";
import axios from "axios";
import { BaleDateReq, BaleInfoReq, BaleQtyUpdateReq, BaleReportReq, BaleReq, TabNameReq } from "@gtpl/shared-models/raw-material-procurement";

export class BaleService {
    URL = connection.DEPLOY_URL + '/bale-generation';
    //     userid = connection.userid;
    //   role=connection.role;
    //   unitId=connection.unit_id;

    async getRmInwardInfo(req:BaleInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmInwardInfo',req)
            .then(res => {
                return res.data
            })
    }

    async createBale(req:BaleReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createBale',req)
            .then(res => {
                return res.data
            })
    }

    async getBaleInfo(req:BaleInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getBaleReportInfo(req?:BaleInfoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleReportInfo',req)
            .then(res => {
                return res.data
            })
    }

    async updateActualBaleQty(req:BaleQtyUpdateReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateActualBaleQty',req)
            .then(res => {
                return res.data
            })
    }

    async getInwardNumberDropDownInfo(req?:TabNameReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInwardNumberDropDownInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getVoucherNumberDropDownInfo(req?:TabNameReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVoucherNumberDropDownInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getAgentDropDownInfo(req:TabNameReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAgentDropDownInfo',req)
            .then(res => {
                return res.data
            })
    }

    async getBaleNumberDropDownInfo(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleNumberDropDownInfo')
            .then(res => {
                return res.data
            })
    }

        async getLotAgainstBaleData(req?:BaleDateReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getLotAgainstBaleData', req)
            .then(res => {
                return res.data
            })
    }

            async getLotDataAgainstBaleDate(req?:BaleDateReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getLotDataAgainstBaleDate', req)
            .then(res => {
                return res.data
            })
    }

        async getBaleReport(req?:BaleReportReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleReport',req)
            .then(res => {
                return res.data
            })
    }

            async getBaleNoForBaleReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleNoForBaleReport')
            .then(res => {
                return res.data
            })
    }

            async getBaleVariantForBaleReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleVariantForBaleReport')
            .then(res => {
                return res.data
            })
    }

            async getBaleQualityForBaleReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBaleQualityForBaleReport')
            .then(res => {
                return res.data
            })
    }

            async getinwardDetailsInBaleReport(req?:BaleReportReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getinwardDetailsInBaleReport',req)
            .then(res => {
                return res.data
            })
    }

            async getinwardQualityForBaleReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getinwardQualityForBaleReport')
            .then(res => {
                return res.data
            })
    }

            async getInwardVariantForBaleReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInwardVariantForBaleReport')
            .then(res => {
                return res.data
            })
    }

            async getInwardVendorForBaleReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInwardVendorForBaleReport')
            .then(res => {
                return res.data
            })
    }

                async getInwardNoForBaleReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInwardNoForBaleReport')
            .then(res => {
                return res.data
            })
    }
}